import React from 'react';

export const IconRemoveBundle = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.668 4.66667L12.09 12.7613C12.066 13.0977 11.9155 13.4125 11.6687 13.6424C11.4219 13.8722 11.0972 14 10.76 14H5.24263C4.90539 14 4.58068 13.8722 4.33389 13.6424C4.0871 13.4125 3.93658 13.0977 3.91263 12.7613L3.33463 4.66667M6.66797 7.33333V11.3333M9.33463 7.33333V11.3333M10.0013 4.66667V2.66667C10.0013 2.48986 9.93106 2.32029 9.80603 2.19526C9.68101 2.07024 9.51144 2 9.33463 2H6.66797C6.49116 2 6.32159 2.07024 6.19656 2.19526C6.07154 2.32029 6.0013 2.48986 6.0013 2.66667V4.66667M2.66797 4.66667H13.3346"
      stroke="#FF615C"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSuperHotBundle = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1359_6446)">
      <path
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
        fill="#F8EBEB"
      />
      <path
        opacity="0.5"
        d="M24.3308 39.7281C21.2954 39.7232 18.3875 38.4304 16.2406 36.1346C14.097 33.8404 12.8877 30.7281 12.8828 27.4815C12.8843 25.3338 13.4119 23.2191 14.4194 21.3223C15.3969 19.4726 16.8367 17.9077 18.5986 16.7797L20.3823 15.6555C20.3823 15.6555 20.2464 16.8108 20.2464 17.629C20.2464 18.4472 20.2121 19.7448 20.7095 20.5303C20.8699 17.071 21.8157 10.7841 26.4434 7.93517L27.9554 7.00244V8.87117C27.9554 12.1603 29.5492 14.2368 31.3966 16.6406C34.0983 19.5223 35.6708 23.3988 35.7919 27.4766C35.787 30.7264 34.5794 33.8421 32.4292 36.1395C30.2806 38.4353 27.3679 39.7264 24.3292 39.7281H24.3308Z"
        fill="#CC0000"
      />
      <path
        d="M26.1574 17.6518C22.001 20.2127 22.4985 27.4323 22.4985 27.4323C21.8687 27.1068 21.3583 26.59 21.0405 25.9563C20.7102 25.3051 20.5815 24.5702 20.6706 23.8454C19.5409 24.5649 18.6178 25.5659 17.9919 26.75C17.3469 27.9637 17.0103 29.3175 17.0117 30.692C17.0117 32.7669 17.7825 34.7567 19.1554 36.2229C20.525 37.6923 22.3855 38.5154 24.3263 38.5154C26.2654 38.5154 28.1259 37.6923 29.4972 36.2245C30.8852 34.7175 31.6511 32.7408 31.6408 30.692C31.6408 24.3281 26.1557 23.0305 26.1557 17.6501L26.1574 17.6518Z"
        fill="#F8EBEB"
      />
    </g>
    <defs>
      <clipPath id="clip0_1359_6446">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconHotBundle = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.801"
      d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
      fill="#FF6600"
      fillOpacity="0.12"
    />
    <path
      d="M26.3084 12.8C20.8947 15.92 21.5444 24.7092 21.5444 24.7092C20.7372 24.3262 20.072 23.6975 19.6442 22.9131C19.2164 22.1287 19.0481 21.2289 19.1633 20.3429C17.7126 21.198 16.5101 22.4168 15.6747 23.8788C14.8392 25.3409 14.3996 26.9956 14.3993 28.6795C14.3824 29.9414 14.6163 31.194 15.0875 32.3648C15.5586 33.5355 16.2577 34.6009 17.1441 35.4993C18.0304 36.3976 19.0864 37.1109 20.2507 37.5978C21.415 38.0846 22.6644 38.3353 23.9264 38.3353C25.1884 38.3353 26.4378 38.0846 27.6021 37.5978C28.7664 37.1109 29.8224 36.3976 30.7088 35.4993C31.5951 34.6009 32.2942 33.5355 32.7654 32.3648C33.2366 31.194 33.4705 29.9414 33.4536 28.6795C33.4536 20.9326 26.3084 19.352 26.3084 12.8Z"
      fill="#FF6602"
    />
  </svg>
);

export const IconRefreshBundle = (props) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
      fill="#E4F3FC"
    />
    <g clipPath="url(#clip0_1359_6632)">
      <path
        d="M32.4717 15.525C31.3616 14.4073 30.0411 13.5203 28.5866 12.9153C27.132 12.3104 25.5721 11.9993 23.9967 12C17.3667 12 12.0117 17.37 12.0117 24C12.0117 30.63 17.3667 36 23.9967 36C29.5917 36 34.2567 32.175 35.5917 27H32.4717C31.8538 28.7543 30.7067 30.2736 29.1887 31.3483C27.6707 32.4229 25.8566 33.0001 23.9967 33C19.0317 33 14.9967 28.965 14.9967 24C14.9967 19.035 19.0317 15 23.9967 15C26.4867 15 28.7067 16.035 30.3267 17.67L25.4967 22.5H35.9967V12L32.4717 15.525Z"
        fill="#0793EA"
      />
    </g>
    <defs>
      <clipPath id="clip0_1359_6632">
        <rect width="36" height="36" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>
);
